<template>
  <div class="proa-loading"/>
</template>

<script>
export default {
  name: 'ProaLoading'
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-loading {
  width: 100%;
  height: 100%;
  border: 0.5rem solid #A0B4C880;
  border-top-color: #A0B4C8;
  border-radius: 50%;
  animation: 1s loading infinite linear;
}

@keyframes loading {
  from{
    transform: rotateZ(0deg);
  }
  to{
    transform: rotateZ(360deg);
  }
}
</style>
